export default function Products() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <h2 className="text-5xl text-center mb-24 text-gray-900" style={{ fontFamily: 'Georgia, serif' }}>Our Products</h2>
        
        <div className="grid grid-cols-3 gap-8" data-product-shop>
          {/* VPN Product Card */}
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-medium text-white mb-3">VPN Protection</h3>
            <p className="text-sm text-gray-300 mb-8">Secure your connection</p>
            <div className="flex justify-center items-center h-96">
              <img 
                src="https://public.readdy.ai/ai/img_res/8e41961571c2775871503243cc585a70.jpg" 
                alt="VPN Protection" 
                className="w-48 h-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>

          {/* Cleaner Product Card */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 relative">
            <div className="absolute top-6 right-6 bg-gray-200 rounded-full px-3 py-1 flex items-center gap-1">
              <span className="text-xs">✨</span>
              <span className="text-xs uppercase font-medium text-gray-600">NEW</span>
            </div>
            <div className="flex flex-col items-center justify-center h-full">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20mockup%20showing%20modern%20cleaner%20application%20interface%20with%20storage%20optimization%20charts%20colorful%20progress%20bars%20and%20clean%20button%20on%20light%20cream%20background%20minimalist%20iOS%20app%20design%20with%20rounded%20elements&width=400&height=800&seq=cleaner-product-001&orientation=portrait" 
                alt="Device Cleaner" 
                className="w-48 h-auto object-contain mb-8 drop-shadow-xl"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Device Cleaner</h3>
              <p className="text-sm text-gray-600">Optimize storage & performance</p>
            </div>
          </div>

          {/* Additional Feature Card */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="flex flex-col items-center justify-center h-full">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20displaying%20iOS%20security%20dashboard%20with%20privacy%20settings%20battery%20optimization%20and%20system%20monitoring%20features%20on%20light%20background%20modern%20clean%20interface%20design%20with%20icons%20and%20status%20indicators&width=400&height=800&seq=feature-product-001&orientation=portrait" 
                alt="Security Suite" 
                className="w-48 h-auto object-contain mb-8 drop-shadow-xl"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Security Suite</h3>
              <p className="text-sm text-gray-600">Complete device protection</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
